import React from 'react';
import { Alert, Button } from 'antd';
import { blockerLabel, HISTORICAL_BLOCKERS } from '../../utilities/blockerLabels';
import { actionReason, capability, money } from '../../utilities/paymentPresentation';
// Why "Unlock invoice" is refused, from projection.lifecycle_blockers.invoice_unlock.
export default function UnlockBlockers({ projection, onRevisePrice }) {
  const rows = projection.lifecycle_blockers?.invoice_unlock || [];
  const unlock = capability(projection, 'can_unlock_invoice');
  const revise = capability(projection, 'can_revise_price');
  const historical = rows.some(row => HISTORICAL_BLOCKERS.has(row.kind));
  return <div className="pv2-stack">
    <Alert type="warning" showIcon message="The invoice can't be unlocked" description={actionReason(unlock)} />
    {rows.length > 0 && <ul className="pv2-blockers">{rows.map((row, index) => <li key={`${row.kind}-${row.id}-${index}`}>
      <span>{blockerLabel(row)}</span><span className="pv2-muted">#{row.id}{row.amount != null ? ` · ${money(row.amount)}` : ''}</span>
    </li>)}</ul>}
    {historical && <Alert type="info" showIcon message="Past payment history keeps the price locked" description="Closing the remaining items will not unlock it. To change the price, revise it and record the customer's answer; existing payments carry over to the new price." />}
    {onRevisePrice && revise.reason_code !== 'PERMISSION_REQUIRED' && <div className="pv2-form-footer"><Button type="primary" disabled={!revise.allowed} title={revise.allowed ? undefined : actionReason(revise)} onClick={onRevisePrice}>Revise price</Button></div>}
  </div>;
}
